import { render, staticRenderFns } from "./TechnicalForcast.vue?vue&type=template&id=38b58c20&scoped=true&"
import script from "./TechnicalForcast.vue?vue&type=script&lang=js&"
export * from "./TechnicalForcast.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalForcast.vue?vue&type=style&index=0&id=38b58c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b58c20",
  null
  
)

export default component.exports